import * as React from 'react';

import { Button, Flex, Input, Typography } from 'antd';

import { AntdRouterLink, PlusOutlinedIcon } from 'components';
import { PATHNAME } from 'utils';

const {
  DEFAULT: { SLUG_SEPARATOR: DEFAULT_SLUG_SEPARATOR },
  LOCAL: {
    SPECIAL_OFFERS: { CREATE_URL: SPECIAL_OFFERS_CREATE_URL },
  },
} = PATHNAME;

type SpecialOffersHeaderProps = {
  searchKey: string;
  handleSearchKey: (searchKey: string) => void;
};

const SpecialOffersHeader = ({
  searchKey,
  handleSearchKey,
  children,
}: React.PropsWithChildren<SpecialOffersHeaderProps>) => (
  <Flex
    gap='small'
    className='mb-5 max-xl:flex-col xl:items-center xl:justify-between'
  >
    <Typography.Title level={1} className='mb-0 text-lg'>
      تخفیف‌های ویژه
    </Typography.Title>
    <Flex gap='small' className='max-xl:flex-wrap'>
      <Input.Search
        allowClear
        styles={{
          affixWrapper: {
            height: '2.5rem',
          },
        }}
        placeholder='جستجوی تخفیف‌های ویژه'
        defaultValue={searchKey}
        onSearch={value => handleSearchKey(value)}
      />
      <React.Fragment>{children}</React.Fragment>
      <AntdRouterLink
        to={`${SPECIAL_OFFERS_CREATE_URL}${DEFAULT_SLUG_SEPARATOR}`}
        className='max-xl:basis-full'
      >
        <Button type='primary' className='w-full' icon={<PlusOutlinedIcon />}>
          افزودن تخفیف ویژه
        </Button>
      </AntdRouterLink>
    </Flex>
  </Flex>
);

export { SpecialOffersHeader };
